
import { mapGetters } from "vuex";
import { mdiCheck, mdiClose } from "@mdi/js";

export default {
  props: ["subMedia", "subName", "video", "profileId", "city"],

  data() {
    return {
      route: this.$route.params.slug,
      mdiCheck,
      mdiClose,

      loadingSubscribe: false,

      nothing: "",
      subscribeProfile: false,
      subscribeDigest: false,
      valid: false,
      email: "",
      emailRules: [
        (v) => !!v || this.$t("validations.e-mail-is-required"),
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("validations.e-mail-must-be-valid"),
      ],
      checkboxRules: [(v) => !!v || " "],
    };
  },

  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      isMobile: "global/getMobileStatus",
    }),
  },

  methods: {
    async handlerSubscribe() {
      if (this.$refs.formSubscribe.validate()) {
        try {
          this.loadingSubscribe = true;

          const bodyData = {
            email: this.email,
          };

          if (this.subscribeProfile) {
            bodyData["profile_id"] = this.profileId;
          }

          if (this.subscribeDigest) {
            bodyData["city_id"] = this.city.id;
          }

          await this.$axios.post("/api/subscribers/add", bodyData);
          this.$notify({
            type: "success",
            message: this.$t("subscribe-success"),
          });
        } catch (error) {
          console.log(error);
        } finally {
          this.$refs.formSubscribe.reset();
          this.$refs.formSubscribe.resetValidation();
          this.loadingSubscribe = false;
        }
      }
    },
  },
};
